module.exports = __webpack_public_path__ + "img/bg8.46cd6abf.png";